module.exports = __webpack_public_path__ + "img/step-8.6ce79ab8.jpg";